import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import OptimizelyProvider from './context/OptimizelyProvider';
import { getEnv } from '../environment';

import GlobalNavInternalContext from './context/GlobalNavInternalContext';
import GlobalNavContent from './GlobalNavContent';
import { UniversalNavigationContext } from './context/UniversalNavigationContext';

const GlobalNav = ({ env, ...props }) => {
  const externalContextData = useContext(UniversalNavigationContext);

  return (
    <OptimizelyProvider>
      <GlobalNavInternalContext.Provider
        // TODO: add user memo hook here
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value={{
          env: getEnv(env),
          mainProps: { env, ...props },
          ...externalContextData,
        }}
      >
        <GlobalNavContent />
      </GlobalNavInternalContext.Provider>
    </OptimizelyProvider>
  );
};

GlobalNav.propTypes = {
  env: PropTypes.string,
  hideCart: PropTypes.bool,
};

GlobalNav.defaultProps = {
  env: '',
  hideCart: false,
};

export default React.memo(GlobalNav);
